var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFD000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "white",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewYellow);
export default __webpack_public_path__ + "static/media/reviewYellow.9c853f0a12f6be48e3381e638ec840af.svg";
export { ForwardRef as ReactComponent };